import React from 'react';
import { Link } from 'react-router-dom';

const CategoryGrid = ({ categories }) => {
  const categoryImages = {
    'automotive': 'https://images.unsplash.com/photo-1583692717320-0c9661d49d9a?crop=entropy&cs=srgb&fm=jpg',
    'pune-local': 'https://images.unsplash.com/photo-1705955463252-e3f670e4041b?crop=entropy&cs=srgb&fm=jpg',
    'industry-insights': 'https://images.unsplash.com/photo-1625690180114-5530b1304127?crop=entropy&cs=srgb&fm=jpg',
    'reviews': 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?crop=entropy&cs=srgb&fm=jpg',
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="category-grid">
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`/category/${category.slug}`}
          className="block group relative overflow-hidden h-64"
          data-testid={`category-card-${category.slug}`}
        >
          <img
            src={categoryImages[category.slug] || 'https://images.unsplash.com/photo-1618353482480-61ca5a9a7879?crop=entropy&cs=srgb&fm=jpg'}
            alt={category.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <h3 className="text-2xl font-bold text-white">{category.name}</h3>
            {category.description && (
              <p className="text-sm text-white/80 mt-2">{category.description}</p>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default CategoryGrid;
